import { Pipe, PipeTransform } from '@angular/core';
@Pipe(
    {name: 'customCurrencyPipe'},
)
// If the value starts with a '-',
// then remove the '-' and wrap the string in parens
export class CustomCurrencyPipe implements PipeTransform {
    transform(value: any, args?: any): any {

        if (value) {
            return value.charAt(0) === '-' ?
            '(' + value.substring(1, value.length) + ')' :
            value;
        } else {
            return value;
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/customCurrencyPipe.pipe.ts